import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import AxiosConfig from "../../../services/AxiosConfig";
import { useModal } from "../../../contexts/ModalContext";
import { ReactComponent as AjouterIcone } from "../../../icons/ajouter.svg";
import styles from "../../../pages/Admin/Admin.module.css";
import SeanceTable from "./SeanceTable";
import FilterHamburgerCustom from "../../Filter/FilterHamburgerCustom";
import TitleSecondary from "../../Title/TitleSecondary";
import SearchUtilisateur from "../../Search/SearchUtilisateur";
import SearchCoach from "../../Search/SearchCoach";
import { ReactComponent as AnnulerIcon } from "../../../icons/annuler.svg";
import LoaderSkeleton from "../../Loader/LoaderSkeleton";
import styles_field from "../../Field/Field.module.css";
import PaginationBar from "../../Pagination/PaginationBar";
import TitleMain from "../../Title/TitleMain";
import Routing from "../../../services/routing";
import styles_filter from "../../Filter/Filter.module.css";
import {updateFilterUri} from "../../../services/FilterService";
import SearchEntreprise from "../../Search/SearchEntreprise";

const SeancesVue = ({   entreprise,
                        contrat,
                        activite,
                        seances,
                        putActifOpenModal = null,
                        handleSubmitSeanceStatus = null,
                        isLoading = false,
                        setPage,
                        page,
                        totalPage,
                        totalSeances,
                        serverSideSorting = false,
                        onSortChange = () => {},
                        initialSortBy = [],
}) => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);

    const submitEntreprise = (values) => {
        queryParams.set('filter_entreprise', values.entrepriseId);
        navigate(`?${queryParams.toString()}`);
    };

    const submitUtilisateur = (values) => {
        queryParams.set('filter_utilisateur', values.id);
        navigate(`?${queryParams.toString()}`);
    };

    const submitCoach = (values) => {
        queryParams.set('filter_coach', values.id);
        navigate(`?${queryParams.toString()}`);
    };

    function setQueryParam(key, value, location, navigate) {
        const queryParams = new URLSearchParams(location.search);
        queryParams.set(key, value);
        navigate(`?${queryParams.toString()}`, { replace: true });
    }

    function deleteQueryParam(key, location, navigate) {
        const queryParams = new URLSearchParams(location.search);
        queryParams.delete(key);
        navigate(`?${queryParams.toString()}`, { replace: true });
    }

    const isValidDate = (date) => {
        return date && !isNaN(Date.parse(date));
    };

    const updateURLParamsDateDebut = (start, end) => {
        if (!isValidDate(start)) {
            console.error("Date de début non valide.");
            return;
        }
        if (end && isValidDate(end) && new Date(start) > new Date(end)) {
            console.error("La date de début ne peut pas être postérieure à la date de fin.");
            return;
        }
        setQueryParam("filter_debut", start, location, navigate);
    };

    const updateURLParamsDateFin = (end, start) => {
        if (!isValidDate(end)) {
            console.error("Date de fin non valide.");
            return;
        }
        if (start && isValidDate(start) && new Date(end) < new Date(start)) {
             // la date de fin ne peut pas être antérieure à la date de début
        }
        setQueryParam("filter_fin", end, location, navigate);
    };

    const removeFilter = (e) => {
        const key = e.currentTarget.querySelector('.filter_key').textContent;
        deleteQueryParam(`filter_${key}`, location, navigate);
    };

    const updateFilter = (filterKey, filterValue, resetFilter = false) => {
        const params = new URLSearchParams(location.search);

        updateFilterUri(params, filterKey, filterValue, resetFilter);

        navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    };

    const childrenOfFilter = (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px", margin: "35px", alignItems: "center" }}>
            <TitleSecondary text="Filtres" />

            <div className={styles.filtersRemoveBar}>
                {Array.from(queryParams.entries())
                    .filter(([key, value]) => key.startsWith('filter_'))
                    .map(([key, value]) => {
                        return (
                            <button key={key} className={styles.btnFilterRemove} onClick={removeFilter}>
                                <AnnulerIcon />
                                <span className={"filter_key"}>{key.replace('filter_', '')}</span> : {value}
                            </button>
                        );
                    })
                }
            </div>

            <div className={styles.formBloc}>
                {!entreprise &&
                    <div>
                        Entreprise :
                        <SearchEntreprise onSubmit={submitEntreprise} selectedEntreprise={entreprise?.id}/>
                    </div>
                }
                <div>
                    Participant :
                    <SearchUtilisateur onSubmit={submitUtilisateur} entrepriseId={entreprise?.id}/>
                </div>

                <div>
                    Coach :
                    <SearchCoach onSubmit={submitCoach} />
                </div>

                <div style={{ marginTop: "6px" }}>
                    <span>Plage de dates personnalisées </span>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        margin: "6px 0"
                    }}>
                        <div className={styles_field.field}>
                            <input type="date" value={queryParams.get("filter_debut") || ""}
                                   onChange={(e) => updateURLParamsDateDebut(e.target.value, queryParams.get("filter_fin"))} />
                        </div>

                        <div className={styles_field.field}>
                            <input type="date" value={queryParams.get("filter_fin") || ""}
                                   onChange={(e) => updateURLParamsDateFin(e.target.value, queryParams.get("filter_debut"))} />
                        </div>
                    </div>
                </div>

                <div>
                    <span>Séances supprimées</span>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "8px",
                        padding: "8px",
                        outline: "1px solid var(--clr-accent)",
                    }}>
                        <button className={styles_filter.btnFiltre}
                                onClick={() => updateFilter('filter_actif', 'false', true)}>
                            Oui
                        </button>

                        <button className={styles_filter.btnFiltre}
                                onClick={() => updateFilter('filter_actif', 'true', true)}>
                            Non
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className="content_tab">
            <TitleMain text="Séances" />
            <div className={styles.navLink}>
            { entreprise && contrat && activite &&
                <Link to={Routing.routes.adminCreation}>
                    <AjouterIcone/>
                    Ajouter une séance
                </Link>
            }
            </div>

            <FilterHamburgerCustom onReinirFilters={() => {
                const queryParams = new URLSearchParams(location.search);
                Object.entries({
                    utilisateur: '',
                    coach: '',
                    debut: '',
                    fin: '',
                    actif: '',
                    entreprise: '',
                }).forEach(([key, value]) => {
                    if (value) {
                        queryParams.append(`filter_${key}`, value);
                    } else {
                        if (queryParams.has(`filter_${key}`)) {
                            queryParams.delete(`filter_${key}`);
                        }
                    }
                });
                navigate(`?${queryParams.toString()}`);
            }} children={childrenOfFilter} />

            {isLoading ? <LoaderSkeleton /> :
                <>
                    <SeanceTable
                        seances={seances}
                        putActifOpenModal={putActifOpenModal}
                        handleSubmitSeanceStatus={handleSubmitSeanceStatus}
                        serverSideSorting={serverSideSorting}  // Passe la prop serverSideSorting
                        onSortChange={onSortChange}                  // Passe la prop fetchData
                        initialSortBy={initialSortBy}
                    />
                    <PaginationBar page={page} totalPage={totalPage} setPage={setPage} totalResult={totalSeances} />
                </>}
        </div>
    );
}

export default SeancesVue;
